<template>
  <div class="my-2 px-2">
    <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
    >
      <div v-if="!route.query.contactId" class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="d-flex align-items-center justify-content-between filter-label">
          <label for="colFormLabel" class="col-form-label">Customer: </label>
          <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
        </div>
        <AsyncSelect
            placeholder="Select Customer"
            v-model="contactProfile"
            :api-service="fetchContactProfiles"
            :additional-query="additionalContactOption"
            :format-label="formatPatientLabel"
            :additional-option="additionalOption"
        />
      </div>
    </DateQuerySetter>
  </div>
  <div class="col-12">
    <div class="d-flex justify-content-end px-2">
      <button
          @click="onClickToPrint"
          class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
      >
        Print
      </button>
      <button
          @click="onClickToExport"
          class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
      >
        Export
      </button>
    </div>
  </div>
  <div class="col-12 px-2 mt-2 mb-4">
    <ListTable
        :tableItems="tableItems"
        :currentPage="(invoiceData && invoiceData.data) && invoiceData.data.current_page"
        :lastPage="(invoiceData && invoiceData.data) &&  invoiceData.data.last_page"
        :perPage="(invoiceData && invoiceData.data) &&  Number(invoiceData.data.per_page)"
        :totalValue="invoiceData && invoiceData.total"
    />
  </div>
  <div class="px-2 position-absolute bottom-0 mt-4">
    <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
  </div>
</template>

<style scoped>

</style>
<script setup>
import { computed, inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/inventory/order-sales-register/InvoiceTabTable.vue'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleContact from "@/services/modules/contact";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handlePurchase from '@/services/modules/purchase'
import invoicePrinter from '@/services/utils/pdf/saleOrderRegisterInvoice';

const { exportToPDF } = invoicePrinter();

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = reactive({
  searchTxt: '',
  offset: 10
});

const contactProfile = ref(null)
const invoiceData = ref( {});
const saleOrderData = ref({});
const additionalOption = ref([]);
const additionalContactOption = ref({
  with_mobile: 1,
  dealer_id: ''
});

const props = defineProps({
  companyInfo: {
    type: Object,
    required: true,
  }
});

const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchSalesOrderRegisterList } = handlePurchase()
const start = computed(() => route.query.start);
const end = computed(() => route.query.end);
const token = computed(() => localStorage.getItem('token'));

const onClickToExport = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/export/reports/sales-order-register${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onClickGo = () => {
  getSaleOrderRegisterList()
}

async function onClickToPrint() {
  let query = getQuery();
  query += '&is_all=true'
  let startDate = route.query.start ? route.query.start : '';
  let endDate = route.query.end ? route.query.end : '';

  let params = {
    contact_profile: !!contactProfile.value,
  }

  await fetchSalesOrderRegisterList(query).then((res) => {
    if (res.status) {
       saleOrderData.value = res
    }
  }).then(() => {
       exportToPDF(props.companyInfo, saleOrderData.value, startDate, endDate, params)
   }).catch((err) => {
     console.log("Something went wrong");
   });
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

async function onPageChange(page) {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getSaleOrderRegisterList();
}

const getSaleOrderRegisterList = async () => {

  const query = getQuery();
  loading.value = true

  await fetchSalesOrderRegisterList(query).then(res => {
    loading.value = false
    if (!res.status){
      tableItems.value = []
      invoiceData.value = {}
      store.commit("resetPagination")
      return
    }
    tableItems.value = res.data.data;
    invoiceData.value = res
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (start.value && end.value) query += `&start_date=${start.value}&end_date=${end.value}`
  if (route.query.page) query += '&page=' + route.query.page
  if(contactProfile.value) query += `&contact_profile_id=${contactProfile.value.id}`;
  query += '&offset=' + params.offset
  return query;
}

onMounted(() => {
  if (route.query.contactId){
     contactProfile.value = {
       id:route.query.contactId,
     }
  }
})
</script>